const getRedirectionRoute = (currentRoute, redirectionRoute) =>
  currentRoute.includes("portal") ? `/portal${redirectionRoute}` : redirectionRoute;

export default getRedirectionRoute;
